var _path, _path2, _circle, _circle2, _circle3, _circle4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipmentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63285 2.00687H13.0337V11.1649H29.9995V16.2428C30.0229 16.9943 29.2657 17.2408 28.8841 17.2702H20.6067H0.940481C0.189056 17.0588 0.00119972 16.3603 0.00119972 16.0374V11.2823C-0.0222816 10.4604 0.30451 9.68745 0.47084 9.4037L5.46077 3.18097C6.11826 2.1008 7.18278 1.94817 7.63285 2.00687Z",
    fill: "#F7C000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6841 9.65694V3.11133H8.45531C7.75085 3.11133 7.28121 3.54183 7.13444 3.75708L2.40869 9.65694H11.6841Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5223,
    cy: 3.5223,
    r: 3.5223,
    transform: "matrix(-1 0 0 1 8.80737 13.7373)",
    fill: "#40596B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.67309,
    cy: 1.67309,
    r: 1.67309,
    transform: "matrix(-1 0 0 1 6.98755 15.5566)",
    fill: "#FDFDFD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5223,
    cy: 3.5223,
    r: 3.5223,
    transform: "matrix(-1 0 0 1 27.0647 13.7373)",
    fill: "#40596B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.67309,
    cy: 1.67309,
    r: 1.67309,
    transform: "matrix(-1 0 0 1 25.2449 15.5566)",
    fill: "#FDFDFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.20475,
    height: 3.73755,
    transform: "matrix(-1 0 0 1 23.0068 7.47461)",
    fill: "#F29A46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.12127,
    height: 1.86878,
    transform: "matrix(-1 0 0 1 21.512 7.47461)",
    fill: "#B1794B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.20475,
    height: 3.73755,
    transform: "matrix(-1 0 0 1 23.0066 0)",
    fill: "#F29A46"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.12127,
    height: 1.86878,
    transform: "matrix(-1 0 0 1 21.5117 0)",
    fill: "#B1794B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4.20475,
    height: 3.73755,
    transform: "matrix(-1 0 0 1 18.4268 7.47461)",
    fill: "#F29A46"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.12127,
    height: 1.86878,
    transform: "matrix(-1 0 0 1 16.9316 7.47461)",
    fill: "#B1794B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4.20475,
    height: 3.73755,
    transform: "matrix(-1 0 0 1 27.5867 7.47461)",
    fill: "#F29A46"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1.12127,
    height: 1.86878,
    transform: "matrix(-1 0 0 1 26.0916 7.47461)",
    fill: "#B1794B"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 4.20475,
    height: 3.73755,
    transform: "matrix(-1 0 0 1 20.5325 3.73828)",
    fill: "#F29A46"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 1.12127,
    height: 1.86878,
    transform: "matrix(-1 0 0 1 19.0374 3.73828)",
    fill: "#B1794B"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 4.20475,
    height: 3.73755,
    transform: "matrix(-1 0 0 1 25.1125 3.73828)",
    fill: "#F29A46"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 1.12127,
    height: 1.86878,
    transform: "matrix(-1 0 0 1 23.6174 3.73828)",
    fill: "#B1794B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentIcon);
export default __webpack_public_path__ + "static/media/shipment-icon.c8054061a4616628fb6c4751122cf856.svg";
export { ForwardRef as ReactComponent };